<ds-item-detail-preview [item]="item"
                        [object]="object"
                        [badgeContext]="badgeContext"></ds-item-detail-preview>

<ds-workspaceitem-actions [object]="dso"></ds-workspaceitem-actions>
